import api from "@/api/order";

const initForm = {
    type: null,
    request: null,
    comment: null,
    order_id: null,
    parent_ticket_id: null,
    products: {},
    products_qty: {}
}

export default {
    state: {
        courierRequests: null,
        form: {
            ...initForm
        }
    },
    getters: {
        getCourierRequestsTypes(state) {
            const {
                courierRequests
            } = state;

            if (!courierRequests) return [];

            return Object.entries(courierRequests.types).map(([id, text]) => {
                return {
                    id: +id,
                    text
                }
            })
        },
        getCourierRequestsRequests(state) {
            const {
                courierRequests
            } = state;
            const {
                type
            } = state.form;

            if (!type || !courierRequests) return [];

            const {
                requests
            } = state.courierRequests;

            return Object.entries(requests[type]).map(([id, text]) => {
                return {
                    id: +id,
                    text
                }
            })
        }
    },
    mutations: {
        SET_COURIER_REQUESTS_DATA(state, payload) {
            state.courierRequests = payload;
        },
        RESET_CREATE_COURIER_REQUEST_FORM(state) {
            state.form = {
                ...initForm
            };
        },
        UPDATE_CREATE_COURIER_REQUEST_FORM(state, payload) {
            state.form = {
                ...state.form,
                ...payload
            }
        },
    },
    actions: {
        async saveCourierRequest({
            dispatch,
            state
        }) {
            dispatch('setIsLoadingData', true);
            const {
                form
            } = state;
            try {
                const result = await api.createRequest(form);
                return Promise.resolve(result.data.data);
            } catch (e) {
                const {
                    response: {
                        data: {
                            data: {
                                messages
                            }
                        }
                    }
                } = e;

                return Promise.reject(messages);
            } finally {
                dispatch('setIsLoadingData', false);
            }
        }
    },
};